import { v4 as uuidv4 } from 'uuid';

import { KnmCollapse } from 'KnmPackage/MainModule/components/KnmCollapse';

import { IKnmHistoryItemChanges } from '../interfaces/IKnmHistoryItemChanges';
import styles from './KnmHistoryItem.module.scss';

interface IKnmHistoryItemProps {
  data: IKnmHistoryItemChanges;
}

export const KnmHistoryItem = ({ data }: IKnmHistoryItemProps) => {
  return (
    <KnmCollapse title={data.title}>
      <>
        {data.changesText.map(changeText => (
          <div className={styles.Patch} key={uuidv4()}>
            {changeText}
          </div>
        ))}
      </>
    </KnmCollapse>
  );
};
